import {AiChatSource} from '@Components/ai-chat-window/ai-chat-window.types';
import {useAppSelector} from '@/hooks';

export function useIsEventsCalendarPromotionChat(chatId: string): boolean {
  return useAppSelector(({aiChatWindow}) => {
    return aiChatWindow[chatId]?.source === AiChatSource.EVENTS_CALENDAR_PROMOTION;
  });
}
